import React from 'react';
import Content404Page, {
  IContent404Page,
} from '@wearesection/bandai-react-components/organisms/Content404Page';
import {GetRouter} from '~/utils';

const handleRenderData = (data: IContent404Page) => {
  const {locale} = GetRouter();

  let newListPropsBtn = [];

  newListPropsBtn =
    data?.listPropsBtn?.map((item: any) => {
      return {
        ...item,
        href: item?.href?.includes('http') ? item?.href : `/${locale}${item?.href}`,
      };
    }) || [];

  const newConfiguration: any = {
    ...data,
    listPropsBtn: newListPropsBtn,
  };

  return newConfiguration;
};

const Content404Organisms: React.FC<IContent404Page | any> = ({content}) => {
  const contentComponent = handleRenderData(content);

  return <Content404Page {...contentComponent} />;
};

export default Content404Organisms;
